import EmployEngageLogo from '../employ-engage-logo/employ-engage-logo';
import { ForwardedRef, forwardRef, Fragment } from 'react';
import NavButton from '../nav-button/nav-button';
import NavSpacer from '../nav-spacer/nav-spacer';
import { NavMenuItem } from '@employ-engage/data';
import classNames from 'classnames';
import EmployEngageLogoSmall from '../employ-engage-logo-small/employ-engage-logo-small';
import { Link } from 'react-router-dom';

export interface AdminSidebarProps {
  navMenu: (NavMenuItem | 'horizontal-rule' | null)[];
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
  transitionDurationClass: string;
}

export const AdminSidebar = forwardRef(
  (
    {
      navMenu,
      isCollapsed,
      setIsCollapsed,
      transitionDurationClass,
    }: AdminSidebarProps,
    ref: ForwardedRef<any>
  ) => {
    return (
      <div
        ref={ref}
        className={classNames(
          'admin-sidebar  h-[100vh] relative bg-white transition-all overflow-hidden shrink-0 overflow-y-auto',
          transitionDurationClass,
          {
            'w-[340px]': !isCollapsed,
            'w-[80px]': isCollapsed,
          }
        )}
      >
        <div
          className={classNames(
            'transition-all top-[170.74px] absolute justify-start items-start gap-2.5 inline-flex',
            {
              'left-[44px]': !isCollapsed,
              'left-0': isCollapsed,
            }
          )}
        >
          <ul className="flex-col justify-start items-start gap-2 inline-flex">
            {navMenu.map((item, index) => {
              return (
                <Fragment key={index}>
                  {!item ? (
                    <NavSpacer key={index} />
                  ) : item === 'horizontal-rule' ? (
                    <li
                      className={classNames(transitionDurationClass, {
                        'w-[252px]': !isCollapsed,
                        'w-[80px]': isCollapsed,
                      })}
                    >
                      <hr className="border-b border-gray-500 w-full" />
                    </li>
                  ) : (
                    <NavButton
                      key={item.title}
                      title={item.title}
                      buttonClassName={item.buttonClassName}
                      iconClassName={item.iconClassName}
                      to={item.to}
                      onClick={item.onClick}
                      isCurrent={item.current}
                      transitionDurationClass={transitionDurationClass}
                      isCollapsed={isCollapsed}
                    />
                  )}
                </Fragment>
              );
            })}
          </ul>
        </div>
        <div
          className={classNames(
            'w-[168px] absolute justify-center items-center inline-flex',
            transitionDurationClass,
            {
              'opacity-100 top-[40px] left-[42px]': !isCollapsed,
              'opacity-0 top-0 left-[20px]': isCollapsed,
            }
          )}
        >
          <Link to="/">
            <EmployEngageLogo />
          </Link>
        </div>
        <div
          className={classNames(
            'w-[80px] absolute justify-center items-center inline-flex',
            transitionDurationClass,
            {
              'opacity-0 top-[75px] left-[33px]': !isCollapsed,
              'opacity-100 top-0 left-0': isCollapsed,
            }
          )}
        >
          <Link to="/">
            <EmployEngageLogoSmall
              height={isCollapsed ? 80 : 40}
              className="text-light-primary transition-all"
            />
          </Link>
        </div>
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className={classNames(
            'absolute top-[80px] cursor-pointer transition-all tr',
            transitionDurationClass,
            {
              'rotate-180 left-[28px]': isCollapsed,
              'left-[281px]': !isCollapsed,
            }
          )}
        >
          <i className="fa-solid fa-arrow-left text-3xl" />
        </button>
        <div className="w-8 left-[313px] top-[96px] absolute origin-top-left rotate-180 flex-col justify-center items-end inline-flex" />
      </div>
    );
  }
);

export default AdminSidebar;
